import { Injectable } from "@angular/core"
import { Action, Selector, State, StateContext } from "@ngxs/store";
import { PatientRelatedStaff } from "./patient-related-staff.action";

export class PatientRelatedStaffStateModel{
    userIds:any;
        // userName:string;
        // roleId:any;
        // roleName:string;
        // userInternalId:any;
 }
 @State<PatientRelatedStaffStateModel>({
    name: 'patStaffIds',
    defaults: {
       userIds:'',
    //    userInternalId:0,
       
    //    userName:'',
       
    //    roleId:0,
    //    roleName:'',
       
     }
})
@Injectable()
 export class PatientRelatedStaffState {
    constructor( ) {
    }

    @Selector()
    static getpatStaffIds(state: PatientRelatedStaffStateModel) {
        return state;
    }

    @Action(PatientRelatedStaff)
    storePatStaffIdsAction({getState, patchState}: StateContext<PatientRelatedStaffStateModel>, {payload}: PatientRelatedStaff) {

        const state = getState();
        patchState({
             userIds:payload?.userIds,
            
            //  userName:payload.userName,
            //  roleName:payload.roleName,
            //  roleId:payload.roleId,
            //  userInternalId:payload.userInternalId
        });
    }
}



 
